/** Application version, bumped manually on each release. */
export const APP_VERSION = 'v18.2.0';
